export default __webpack_public_path__ + "static/media/kestrel10.0d7b44e8.jpg";